var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33329 11.8249V15.6749C7.33329 18.8833 8.61662 20.1666 11.825 20.1666H15.675C18.8833 20.1666 20.1666 18.8833 20.1666 15.6749V11.8249C20.1666 8.61659 18.8833 7.33325 15.675 7.33325H11.825C8.61662 7.33325 7.33329 8.61659 7.33329 11.8249Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83329 6.32492V10.1749C1.83329 13.3833 3.11662 14.6666 6.32496 14.6666H7.33329V11.8249C7.33329 8.61659 8.61662 7.33325 11.825 7.33325H14.6666V6.32492C14.6666 3.11659 13.3833 1.83325 10.175 1.83325H6.32496C3.11662 1.83325 1.83329 3.11659 1.83329 6.32492Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDuplicate);
export default __webpack_public_path__ + "static/media/menu-duplicate.a8b6db2dc3445d4dc372663309008f2c.svg";
export { ForwardRef as ReactComponent };